module.exports = __webpack_public_path__ + "static/img/l_cp.8eca2b72.png";